/**
 * File navigation.js.
 *
 * NOTE - this file handles only the Desktop Menu events and DOES NOT handle any Tab Key events.
 */

export default class mainMenu {
	constructor() {
		this.active_class = '--is-active'
		this.navigation_wrapper = document.querySelector('#site-navigation')
		this.secondary_menus = document.querySelectorAll('.sub-menu__secondary')

		this.tertiary_menu_children_class = '.sub-menu__item'

		this.search_bar_toggle = document.querySelector('#desktop-search-toggle')
		this.search_bar = document.querySelector('.search-bar')
		this.search_bar_input = this.search_bar.querySelector('.search-field')

		this.secondary_menu_wrappers = this.navigation_wrapper.querySelectorAll('.sub-menu')
		this.secondary_menu_item_links = this.navigation_wrapper.querySelectorAll('.sub-menu__item-link')

		this.init()
	}

	init() {
		this.addTertiaryMenuActions()
		this.addSearchIconClickEvents()
		this.toggleSubMenuVisibilityOnClickEvents()
	}

	// Add mouseover event listeners to all secondary menu items in order to show / hide their respective tertiary menu targets.
	addTertiaryMenuActions() {
		const all_tertiary_menus = []

		this.getTertiaryMenuParents().forEach(parent => {
			const tertiary_target = document.querySelector(parent.dataset.tertiaryTarget)

			if (tertiary_target) {
				all_tertiary_menus.push(tertiary_target)				

				// Give and remove active classes to respective elements
				parent.addEventListener('mouseenter', () => {
					this.addTertiaryMenuHoverEvents(all_tertiary_menus, parent, tertiary_target);
					this.addTertiaryMenuCursorEvents();
				})

				parent.addEventListener('mouseleave', (e) => {
					if (e.relatedTarget != tertiary_target) {
						this.addTertiaryMenuHoverEvents(all_tertiary_menus);
					}
				})

				tertiary_target.addEventListener('mouseleave', (e) => {
					if (e.relatedTarget != parent) {
						this.addTertiaryMenuHoverEvents(all_tertiary_menus);
					}
				})
			}
		})
	}

	getTertiaryMenuParents() {
		return this.navigation_wrapper.querySelectorAll('[data-tertiary-target]');
	}

	// Reset active classes on all parents and tertiary targets
	addTertiaryMenuHoverEvents(all_tertiary_menus, active_parent = null, active_tertiary_target = null) {
		this.getTertiaryMenuParents().forEach(parent => {
			if (parent != active_parent) {
				parent.classList.remove(this.active_class);
			} else {
				parent.classList.add(this.active_class)
			}
		});
		
		all_tertiary_menus.forEach(tertiary_menu => {
			if (tertiary_menu != active_tertiary_target) {
				tertiary_menu.classList.remove(this.active_class);
			} else {
				tertiary_menu.classList.add(this.active_class)
			}
		});
	}

	addTertiaryMenuCursorEvents() {
		const all_tertiary_menus = []

		this.getTertiaryMenuParents().forEach(parent => {
			const tertiary_target = document.querySelector(parent.dataset.tertiaryTarget)

			if (tertiary_target) {
				all_tertiary_menus.push(tertiary_target)
			}
		})

		if (all_tertiary_menus) {
			all_tertiary_menus.forEach(tertiary_menu => {
				const tertiary_menu_child_items = tertiary_menu.querySelectorAll(this.tertiary_menu_children_class);

				if (tertiary_menu_child_items) {
					tertiary_menu_child_items.forEach(menu_item => {
						this.removeCursorEvents(menu_item)
					});

					tertiary_menu.addEventListener('mouseenter', () => {
						if (tertiary_menu_child_items) {
							tertiary_menu_child_items.forEach(menu_item => {
								this.addCursorEvents(menu_item)
							});
						}
					})
				}
			});
		}
	}

	addSearchIconClickEvents() {
		if (this.search_bar_toggle) {
			this.search_bar_toggle.addEventListener('click', () => {
				this.toggleSearchBar()
				this.toggleSearchIcon()
				this.toggleNavigationWrapper()

				// Fake the search bar input click when toggling
				if (this.search_bar.classList.contains(this.active_class)) {
					this.focusSearchBarInput()
				}
			})
		}
	}

	removeCursorEvents(el) {
		el.style.pointerEvents = 'none';
	}

	addCursorEvents(el) {
		el.style.pointerEvents = 'all';
	}

	toggleSearchBar() {
		this.search_bar.classList.toggle(this.active_class)
	}
	
	toggleSearchIcon() {
		this.search_bar_toggle.classList.toggle(this.active_class)
	}

	focusSearchBarInput() {
		this.search_bar_input.focus()
	}

	// Add toggle to navigation wrapper to hide sub-menus when search bar is visible
	toggleNavigationWrapper() {
		this.navigation_wrapper.classList.toggle(this.active_class)
	}

	// When clicking on a sub menu item, we want to hide the sub menu
	toggleSubMenuVisibilityOnClickEvents() {
		if (this.secondary_menu_item_links) {
			this.secondary_menu_item_links.forEach(s_menu_link => {
				s_menu_link.addEventListener('click', (e) => {

					// Add the class to hide the submenus using JS and then remove it instantly ONLY IF the link is not a #
					if (!e.target.href.endsWith('#')) {
						this.secondary_menu_wrappers.forEach(wrapper => {
							wrapper.classList.add('--remove-hover');
							setTimeout(() => {
								wrapper.classList.remove('--remove-hover');
							}, 10);
						});
					}
				});
			});
		}
	}
}

new mainMenu()